@import '../Field/field.css';
@import '../es-input/es-input.css';

/**
 * @prop --field-grid-columns: The field layout.
 **/

:host {
    display: block;
}

.input {
    height: 40px;
    border-radius: 20px;
    width: 100%;

    border-width: 1px;
    border-style: solid;
    border-color: var(--color-shade-50);
    outline: none;
    padding: 0 20px;
    transition-property: border-color;
    transition-duration: 200ms;

    font-family: inherit;
    font-weight: 400;
    font-size: 16px;
    color: var(--color-text);

    &:disabled {
        color: var(--color-disabled-contrast);
        border-color: var(--color-disabled-border);
        background-color: var(--color-disabled);
        border-style: dashed;
    }

    &.open {
        border-color: transparent;
    }

    &::placeholder {
        color: var(--color-shade-50);
    }
}

.value_list {
    display: grid;
    align-items: center;
    grid-template-columns: var(
        --field-grid-columns,
        [before] 1fr [input] 350px [after] 1fr
    );
    grid-auto-columns: auto;
    column-gap: var(--field-grid-gap, 15px);
    row-gap: var(--field-grid-gap, 15px);
    padding: 0;
    padding-top: var(--field-grid-gap, 15px);
    padding-bottom: var(--field-grid-gap), 15px;
    margin: 0;
}

.value_list_item {
    display: contents;
}

.value_list_item_icon {
    margin-left: auto;
}
